import { Page } from '@/core/architecture'

import { EventCollectionDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * EventCollectionDetail Page
 * Implemented as a practical sample.
 */
export const EventCollectionDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <EventCollectionDetailTemplate state={state} {...actions} />
}
